import { BsThreeDots } from "react-icons/bs";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

export const Pagination = ({ currentPage, totalPages, changePage }) => {
  const getPaginationRange = () => {
    const delta = 1;
    const range = [];
    const left = currentPage - delta;
    const right = currentPage + delta;

    const withDots = [];
    let l;

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= left && i <= right)) {
        range.push(i);
      }
    }

    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          withDots.push(l + 1);
        } else if (i - l > 2) {
          withDots.push("...");
        }
      }
      withDots.push(i);
      l = i;
    }

    return withDots;
  };

  const paginationRange = getPaginationRange();

  return (
    <div className="flex items-stretch border rounded-md border-[#DEDEDE] w-max text-[#111111]  overflow-hidden">
      <button
        className="sm:px-3 px-2 py-1.5 border-r border-[#DEDEDE]  "
        onClick={() => changePage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <IoIosArrowBack />
      </button>

      {paginationRange.map((page, index) =>
        page === "..." ? (
          <span
            key={index}
            className="sm:px-3 px-2 py-1.5 border-r flex items-center  "
          >
            <BsThreeDots />
          </span>
        ) : (
          <button
            key={index}
            onClick={() => changePage(page)}
            className={`sm:px-3 px-2 py-1.5 border-r border-[#DEDEDE] ${
              currentPage === page
                ? " font-semibold text-[#d3d3d3] bg-[#2b2a2a]"
                : "text-[#111111]"
            }`}
          >
            {page}
          </button>
        ),
      )}

      <button
        className="sm:px-3 px-2 py-1.5 "
        onClick={() => changePage(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <IoIosArrowForward />
      </button>
    </div>
  );
};
